"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionFlag = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
function RegionFlag() {
    var _a;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var className = classnames_1.default((_a = {},
        _a[classPrefix + "-flag"] = true,
        _a[classPrefix + "-flag-Globe--gray"] = true,
        _a));
    return react_1.default.createElement("span", { className: className });
}
exports.RegionFlag = RegionFlag;
RegionFlag.displayName = "RegionFlag";
//# sourceMappingURL=RegionFlag.js.map